import { z } from 'zod';
import { ContentData, ContentDataSchema } from './content-data';
import { SectionData } from './section-data';

// TODO: Add schemas for all section types.
const SectionDataSchema = z.looseObject({});

export const ContentSectionsSchema = z.object({
  content: z.record(z.string(), z.array(ContentDataSchema)),
  sections: z.record(z.string(), SectionDataSchema),
});

export type ContentSections<T = SectionData> = {
  content: {
    [contentArea: string]: ContentData[];
  };
  sections: {
    [sectionId: string]: T;
  };
};
